// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"79e29bd6","239":"dbafbf49","732":"0bdffd4c"}[chunkId] + ".chunk.js";
};